import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { SelectCustom } from '../../../../../common/selectCustom'
import { selectUserType } from '../../../../../layout/store/slice'
import classes from '../../../../index.module.scss'
import {
  changeListValidVolume,
  selectBuyPackage,
  selectUniquePackageTypes,
  setListPackage,
} from '../../../store/slice'
import { getPricingPackages } from '../../../store/thunk'
import {
  getDiscountIdtPriceByVolume,
  getDiscountedPriceByVolume,
  getMaxVolumeInPricingPackage,
  getPricingPackageIdByVolume,
} from '../../helper'
import { BUY_MORE_PACKAGE_ID } from '../BuyMorePackages'
import { VolumeInputArea } from './VolumeInputArea'
import { Price } from './price'

const ONE_PACKAGE = 1

export const PackageItem = ({
  isBuyOnePackage,
  itemIndex,
  defaultReportId,
  appendStylePrice,
  classNamePrice,
  subscriptionType,
}) => {
  const dispatch = useDispatch()

  const userType = useSelector(selectUserType)
  const packageTypes = useSelector(selectUniquePackageTypes)
  const buyPackage = useSelector(selectBuyPackage)
  const locale = useSelector((state) => state.i18n.locale)

  const listPackage = buyPackage?.listPackage

  const selectionPackageTypes = packageTypes.map((item) => ({
    ...item,
    label: item.name,
    value: item.id,
    key: item.id,
  }))

  useEffect(() => {
    dispatch(
      getPricingPackages({
        userType: subscriptionType ? subscriptionType : userType?.userTypeId,
      }),
    )
  }, [locale, userType, subscriptionType])

  return isBuyOnePackage ? (
    <OnePackageItem
      selectionPackageTypes={selectionPackageTypes}
      listPackage={listPackage}
      defaultReportId={defaultReportId}
      classNamePrice={classNamePrice}
      appendStylePrice={appendStylePrice}
    />
  ) : (
    <MorePackageItem
      selectionPackageTypes={selectionPackageTypes}
      itemIndex={itemIndex}
      listPackage={listPackage}
      classNamePrice={classNamePrice}
      appendStylePrice={appendStylePrice}
    />
  )
}
//Buy One Package only
const OnePackageItem = ({
  selectionPackageTypes,
  listPackage,
  defaultReportId,
  classNamePrice,
  appendStylePrice,
}) => {
  const FIRST_INDEX = 0

  const dispatch = useDispatch()

  const [maxVolume, setMaxVolume] = useState(0)
  const [unitPrice, setUnitPrice] = useState(0)
  const [pricingPackageId, setPricingPackageId] = useState(0)
  const [discountId, setDiscountId] = useState({})

  const currentPackageItem = listPackage[FIRST_INDEX]
  const currentPackageItemVolume = currentPackageItem?.volume

  const isContactUs = currentPackageItemVolume >= maxVolume

  const packageType =
    selectionPackageTypes?.find(
      (item) => item.id === currentPackageItem?.packageTypeId,
    ) ||
    selectionPackageTypes?.find((item) => item.id === defaultReportId) ||
    selectionPackageTypes[FIRST_INDEX]

  const totalPrice = currentPackageItemVolume * unitPrice || null

  const setPackageType = (packageType) => {
    const newListPackage = listPackage.map((item, index) =>
      index === FIRST_INDEX
        ? {
            ...item,
            totalPrice: totalPrice,
            unitPrice: unitPrice,
            packageTypeId: packageType?.id,
            packageTypeName: packageType?.name,
            pricingPackageId: pricingPackageId,
            ...discountId,
          }
        : { ...item },
    )
    dispatch(setListPackage(newListPackage))
  }

  useEffect(() => {
    if (packageType && packageType?.discountedPrice.length) {
      setUnitPrice(
        getDiscountedPriceByVolume(
          currentPackageItemVolume,
          packageType?.discountedPrice,
        ),
      )
      setPricingPackageId(
        getPricingPackageIdByVolume(
          currentPackageItemVolume,
          packageType?.discountedPrice,
        ),
      )
      setDiscountId(
        getDiscountIdtPriceByVolume(
          currentPackageItemVolume,
          packageType?.discountedPrice,
        ),
      )
      setMaxVolume(getMaxVolumeInPricingPackage(packageType?.discountedPrice))
    }
  }, [packageType])

  useEffect(() => {
    const newListPackage = listPackage.map((item, index) =>
      index === FIRST_INDEX
        ? {
            ...item,
            totalPrice: totalPrice,
            unitPrice: unitPrice,
            packageTypeId: packageType?.id,
            packageTypeName: packageType?.name,
            pricingPackageId: pricingPackageId,
            isContactUs: isContactUs,
            ...discountId,
          }
        : { ...item, ...discountId },
    )
    dispatch(setListPackage(newListPackage))
  }, [totalPrice])

  return (
    <>
      <PackageType
        selectionPackageTypes={selectionPackageTypes}
        setPackageType={setPackageType}
        packageType={packageType}
      />
      <VolumeInputArea itemIndex={0} />
      <Price
        title="userManagement.buyPackage.UNIT_PRICE"
        price={unitPrice ?? 0}
        appendStylePrice={appendStylePrice}
        classNamePrice={classNamePrice}
        isShowContactUs={isContactUs}
      />
      <Price
        title="userManagement.buyPackage.TOTAL_PRICE"
        price={totalPrice ?? 0}
        appendStylePrice={appendStylePrice}
        classNamePrice={classNamePrice}
      />
    </>
  )
}
//Buy More than one Package
const MorePackageItem = ({
  selectionPackageTypes,
  itemIndex,
  listPackage,
  appendStylePrice,
  classNamePrice,
}) => {
  const dispatch = useDispatch()

  const [maxVolume, setMaxVolume] = useState(0)
  const [unitPrice, setUnitPrice] = useState(0)
  const [pricingPackageId, setPricingPackageId] = useState(0)
  const [discountId, setDiscountId] = useState({})

  const currentPackageItem = listPackage[itemIndex]
  const currentPackageItemVolume = currentPackageItem?.volume

  const isContactUs = currentPackageItemVolume >= maxVolume

  const packageType =
    selectionPackageTypes?.find(
      (item) => item.id === currentPackageItem?.packageTypeId,
    ) || selectionPackageTypes[0]

  const totalPrice = currentPackageItemVolume * unitPrice || null

  const setPackageType = (packageType) => {
    const newListPackage = listPackage.map((item, index) =>
      index === itemIndex
        ? {
            ...item,
            totalPrice: totalPrice,
            unitPrice: unitPrice,
            packageTypeId: packageType?.id,
            packageTypeName: packageType?.name,
            pricingPackageId: pricingPackageId,
            ...discountId,
          }
        : { ...item },
    )
    dispatch(setListPackage(newListPackage))
  }

  const onDeleteBtnClick = (itemIndex) => {
    dispatch(
      setListPackage(listPackage?.filter((item, index) => index !== itemIndex)),
    )
    dispatch(
      changeListValidVolume({
        [itemIndex]: true,
      }),
    )
  }

  useEffect(() => {
    if (packageType && packageType?.discountedPrice.length) {
      setUnitPrice(
        getDiscountedPriceByVolume(
          currentPackageItemVolume,
          packageType?.discountedPrice,
        ),
      )
      setPricingPackageId(
        getPricingPackageIdByVolume(
          currentPackageItemVolume,
          packageType?.discountedPrice,
        ),
      )
      setDiscountId(
        getDiscountIdtPriceByVolume(
          currentPackageItemVolume,
          packageType?.discountedPrice,
        ),
      )
      setMaxVolume(getMaxVolumeInPricingPackage(packageType?.discountedPrice))
    }
  }, [packageType])

  useEffect(() => {
    const newListPackage = listPackage.map((item, index) =>
      index === itemIndex
        ? {
            ...item,
            totalPrice: totalPrice,
            unitPrice: unitPrice,
            packageTypeId: packageType?.id,
            packageTypeName: packageType?.name,
            pricingPackageId: pricingPackageId,
            isContactUs: isContactUs,
            ...discountId,
          }
        : { ...item },
    )
    dispatch(setListPackage(newListPackage))
  }, [totalPrice])

  return (
    <div className={classes.packageItemContainer}>
      <div className="flexRow justifyContentBetween">
        <PackageType
          selectionPackageTypes={selectionPackageTypes}
          setPackageType={setPackageType}
          packageType={packageType}
        />
        {listPackage.length > ONE_PACKAGE && (
          <Element className={classes.buttons}>
            <Element
              className={classes.iconDelete}
              onClick={() => onDeleteBtnClick(itemIndex)}
            >
              <Icon
                className="icon-trash-fill"
                style={{ fontSize: 15, color: '#9C9C9C' }}
              />
            </Element>
          </Element>
        )}
      </div>
      <VolumeInputArea itemIndex={itemIndex} />
      <Price
        title="userManagement.buyPackage.UNIT_PRICE"
        price={unitPrice ?? 0}
        appendStylePrice={appendStylePrice}
        classNamePrice={classNamePrice}
        isShowContactUs={isContactUs}
      />
      {!isContactUs && (
        <Price
          title="userManagement.buyPackage.TOTAL_PRICE"
          price={totalPrice ?? 0}
          appendStylePrice={appendStylePrice}
          classNamePrice={classNamePrice}
        />
      )}
    </div>
  )
}

export const PackageType = ({
  selectionPackageTypes,
  setPackageType,
  packageType,
}) => {
  return (
    <div className={[classes.fieldRow, 'flexRow alignItemsCenter'].join(' ')}>
      <Element className={[classes.firstTwoTitle, 'fw600'].join(' ')}>
        <Translate value="userManagement.buyPackage.PACKAGE_TYPE" />
      </Element>
      <SelectCustom
        data={selectionPackageTypes}
        chooseItem={setPackageType}
        style={{
          width: 210,
          color: '#3A414B',
        }}
        styleDropdown={{ width: 200 }}
        isI18n={false}
        activeItem={packageType}
        zIndex={14}
        scrollId={BUY_MORE_PACKAGE_ID}
      />
    </div>
  )
}
